"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Select = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Select = function Select(_ref) {
  var displayKey = _ref.displayKey,
      options = _ref.options,
      field = _ref.field,
      label = _ref.label,
      flexDirection = _ref.flexDirection;
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: field.input.name,
    style: {
      display: 'flex',
      flexDirection: flexDirection
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, label), /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, field.input, {
    name: field.input.name,
    id: field.input.name
  }), options.map(function (item, i) {
    var itmeInstanceofObject = item instanceof Object;
    var displayValue = itmeInstanceofObject ? item[displayKey] : item;
    var optionValue = itmeInstanceofObject ? JSON.stringify(item) : item;
    return /*#__PURE__*/_react.default.createElement("option", {
      value: optionValue,
      key: i
    }, displayValue);
  })));
};

exports.Select = Select;
var _default = Select;
exports.default = _default;
Select.propTypes = {
  /**
   * The flex-direction CSS property sets how flex items are placed in the flex container defining
   the main axis and the direction (normal or reversed).
   * https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction
   */
  flexDirection: _propTypes.default.string,
  field: _propTypes.default.shape({
    input: _propTypes.default.shape({
      name: _propTypes.default.string
    })
  }),

  /** options for select */
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape, _propTypes.default.string, _propTypes.default.number, _propTypes.default.shape()])).isRequired,

  /**
   * If passing an array of objects to the select
   * then use displayKey to show the key value in the select
   */
  displayKey: _propTypes.default.string,
  label: _propTypes.default.string
};
Select.defaultProps = {
  flexDirection: 'column',
  field: {},
  displayKey: '',
  label: ''
};